__turbopack_context__.v({
  "backdrop": "genericModal-module___OaUpW__backdrop",
  "closeButton": "genericModal-module___OaUpW__closeButton",
  "container": "genericModal-module___OaUpW__container",
  "containerLeft": "genericModal-module___OaUpW__containerLeft",
  "message": "genericModal-module___OaUpW__message",
  "overrideFont": "genericModal-module___OaUpW__overrideFont",
});
